import { lazy } from "react";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const CashReport = ScreenLoader(lazy(() => import("../screens/CashReport")));

export const CashReportRoute = () => ({
  path: "cash-report",
  element: (
    <AuthGuard>
      <RoleGuard requiredPermission="cashReport" requiredActions={["isRead"]}>
        <CashReport />
      </RoleGuard>
    </AuthGuard>
  ),
});
